import React from "react";
import { Outlet } from "react-router-dom";

const UserManagementIndex = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default UserManagementIndex;
